import * as MiniIBEActions from '../actions/mini-ibe.actions';
import * as MiniIBEState from '../states/mini-ibe.indra.state';

export class State extends MiniIBEState.State { }

const initialState: MiniIBEState.State = MiniIBEState.initialState;

/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {MiniIBEActions.Actions} action
 * @returns {MiniIBEState.State}
 */
export function reducer(state = initialState, action: MiniIBEActions.Actions): MiniIBEState.State {

	switch (action.type) {
		case MiniIBEActions.ActionTypes.LOADING:
			state = Object.assign({}, state, { loading: true });
			return state;
		case MiniIBEActions.ActionTypes.PUT_FLIGHT_TYPE:
			state = Object.assign({}, state, { loading: false, flight_type: action.payload });
			return state;
		case MiniIBEActions.ActionTypes.PUT_ROUTE_TYPE:
			state = Object.assign({}, state, { loading: false, route_type: action.payload });
			return state;
		case MiniIBEActions.ActionTypes.PUT_ACTIVE_INPUT:
			state = Object.assign({}, state, { loading: false, activeInput: action.payload });
			return state;
		case MiniIBEActions.ActionTypes.PUT_CURRENT_SEACH_ROUTE:
			state = Object.assign({}, state, { loading: false, current_seach_route: action.payload });
			return state;
		case MiniIBEActions.ActionTypes.SWAP_SEARCH_ROUTE:
			const aux = state.search_routes.slice(0);
			aux[action.payload] = Object.assign({}, aux[action.payload],
				{
					arrival: aux[action.payload].departure,
					departure: aux[action.payload].arrival
				});
			state = Object.assign({}, state, { loading: false, search_routes: aux });
			return state;
		case MiniIBEActions.ActionTypes.PUT_SEARCH_ROUTES:
			if (state.activeInput === 'to') {
				const temp = state.search_routes.slice(0);
				temp[state.current_seach_route] = Object.assign({}, temp[state.current_seach_route], { arrival: action.payload });
				state = Object.assign({}, state, { search_routes: temp });
			} else if (state.activeInput === 'from') {
				const temp = state.search_routes.slice(0);
				temp[state.current_seach_route] = Object.assign({}, temp[state.current_seach_route], { departure: action.payload });
				state = Object.assign({}, state, { search_routes: temp });
			} else if (state.activeInput === 'date') {
				const temp = state.search_routes.slice(0);
				temp[state.current_seach_route] = Object.assign({}, temp[state.current_seach_route], { date: action.payload });
				state = Object.assign({}, state, { search_routes: temp });
			} else {
				state = Object.assign({}, state, { loading: false, search_routes: action.payload });
			}
			return state;
		case MiniIBEActions.ActionTypes.PUT_PASSENGERS:
			state = Object.assign({}, state, { loading: false, passengers: action.payload });
			return state;

		case MiniIBEActions.ActionTypes.PUT_STOPOVERS:
			state = Object.assign({}, state, { loading: false, stopovers: action.payload });
			return state;
			
		case MiniIBEActions.ActionTypes.PUT_RANGE_DATES:
			state = Object.assign({}, state, { rangeDates: action.payload });
			return state;

		case MiniIBEActions.ActionTypes.PUT_DATE_ONE:
			state = Object.assign({}, state, { dateOne: action.payload });
			return state;
		
		case MiniIBEActions.ActionTypes.PUT_IS_STOPOVER:
			state = Object.assign({}, state, { isStopover: action.payload });
			return state;
			
		case MiniIBEActions.ActionTypes.RESET:
			state = Object.assign({}, state, initialState);
			return state;
		
		case MiniIBEActions.ActionTypes.PUT_DEEPLINK_PARAMS:
			state = Object.assign({}, state, { deeplinkParams: action.payload });
			return state;

		default:
			return state;
	}
}

export const getLoading = (state: MiniIBEState.State) => state.loading;
export const getFlightType = (state: MiniIBEState.State) => state.flight_type;
export const getActiveInput = (state: MiniIBEState.State) => state.activeInput;
export const getCurrentSearchRoute = (state: MiniIBEState.State) => state.current_seach_route;
export const getRouteType = (state: MiniIBEState.State) => state.route_type;
export const getSearchRoutes = (state: MiniIBEState.State) => state.search_routes;
export const getCurrentRoute = (state: MiniIBEState.State) => state.search_routes[state.current_seach_route];
export const getPassengers = (state: MiniIBEState.State) => state.passengers;
export const getStopovers = (state: MiniIBEState.State) => state.stopovers;
export const getRangeDates = (state:MiniIBEState.State)=>state.rangeDates;
export const getDateOne = (state:MiniIBEState.State)=>state.dateOne;
export const getIsStopOver = (state:MiniIBEState.State)=>state.isStopover;
export const getDeeplinkParams = (state: MiniIBEState.State)=>state.deeplinkParams;
